import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import IconButton from "@material-ui/core/IconButton";

const useStyles = makeStyles((theme) => ({
  options: {
    width: "50",
    height: "20",
    display: "flex",
    marginLeft: "auto",
    marginTop: 15,
  },
  language: {
    marginTop: 5,
    marginLeft: 20,
  },
  tr: {
    cursor: "pointer",
  },
  en: {
    cursor: "pointer",
  },
  themeSwitch: {},
}));

export default function Settings({ darkMode, setDarkMode}) {
  const classes = useStyles();

  const switchTheme = () => {
    if (darkMode === "true") {
      localStorage.setItem("darkMode", "false");
      setDarkMode("false");
    } else {
      localStorage.setItem("darkMode", "true");
      setDarkMode("true");
    }
  };

  return (
    <div className={classes.options}>
      <IconButton
        color="inherit"
        aria-label="Switch Theme"
        onClick={() => switchTheme()}
        edge="start"
        className={classes.themeSwitch}
      >
        <Brightness4Icon />
      </IconButton>
      {}
    </div>
  );
}
